import styled from 'styled-components';

const MemberRecognitionContainer= styled.div`
  display: flex;
  padding: 0px;
  align-items: center;
  width: 20px;
  height: 20px;
  gap: 5px;
  .Hover {
    :hover {
      cursor: pointer;
    }
  }
`;

export default MemberRecognitionContainer;


